import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import TagAndArchiveContent from '@/components/blog/TagAndArchiveContent';
import { PAGE_TYPE } from '@/constants/datalayer';
import { PAGES } from '@/constants/pages';
import { useAppSelector } from '@/redux';
import { useServices } from '@/services/useServices';
import { updateUrlWithParams } from '@/utils/blogUtils';

export const TagBlogPage = ({ tag, articlesResult }) => {
	const currentPageUrl = `${PAGES.BLOG}/${tag.content[0].urlKeyword}`;
	const { datalayerService, seoService } = useServices();
	const { storeId } = useAppSelector(({ root }) => root.storeConf);
	const router = useRouter();

	const [articlesList, setArticlesList] = useState(articlesResult);
	const [scrollTo, setScrollTo] = useState(false);

	useEffect(() => {
		datalayerService.pushPageName(PAGE_TYPE.BLOG_TAG, PAGE_TYPE.BLOG_TAG);
	}, []);

	const filterByPage = async (page) => {
		const queryParam = tag.id;
		const filteredArticlesList = await seoService.getFilteredTagBlogData(storeId, queryParam, page);

		setArticlesList(filteredArticlesList);
		setScrollTo(true);
		updateUrlWithParams({ router, currentPageUrl, page });
	};

	useEffect(() => {
		setArticlesList(articlesResult);
	}, [articlesResult]);

	return (
		<TagAndArchiveContent
			title={tag.content[0].title}
			articlesList={articlesList}
			paginationCateg={tag?.content[0]}
			filterArticlesList={filterByPage}
			moreDetails={tag.content[0].description}
			scrollTo={scrollTo}
		/>
	);
};

TagBlogPage.propTypes = {
	articlesResult: PropTypes.shape({
		content: PropTypes.array.isRequired,
		pageable: PropTypes.object.isRequired,
		totalElements: PropTypes.number.isRequired,
		totalPages: PropTypes.number.isRequired,
	}).isRequired,
	tag: PropTypes.shape({
		content: PropTypes.array.isRequired,
		id: PropTypes.string.isRequired,
	}),
};

export default TagBlogPage;
